var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartContainer",staticClass:"chart-container",attrs:{"id":'container_chart_'+_vm.randId}},[_c('canvas',{attrs:{"id":'chart_'+_vm.randId,"width":_vm.width,"height":_vm.height},on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }